export function getCategoryImages(careers) {
  const categories = {};

  return careers.map((career) => {
    const variantCareer = career;

    if (!(career.categorytitleEn in categories)) {
      categories[`${career.categorytitleEn}`] = 0;
      variantCareer.categoryImageVariant = career.categoryImageUrl1;

      return variantCareer;
    }

    categories[`${career.categorytitleEn}`] =
      (categories[`${career.categorytitleEn}`] + 1) % 3;

    switch (categories[`${career.categorytitleEn}`]) {
      case 0:
        variantCareer.categoryImageVariant = career.categoryImageUrl1;
        break;
      case 1:
        variantCareer.categoryImageVariant = career.categoryImageUrl2;
        break;
      case 2:
        variantCareer.categoryImageVariant = career.categoryImageUrl3;
        break;
      default:
        variantCareer.categoryImageVariant = career.categoryImageUrl1;
    }

    return variantCareer;
  });
}
